import "babel-polyfill";
import "promise-polyfill";
import Vue from "vue";
import { AutoComplete } from "ant-design-vue";
import App from "./App";
import store from "./store";
import router from "./router";
// import axios from 'axios'
import x2js from "x2js"; //xml数据处理插件
import ELEMENT from "element-ui";
import Viewer from "v-viewer";
import Print from "vue-print-nb";
import uploader from "vue-simple-uploader";
import NProgress from "nprogress";
import Lwfs from "leaflet-wfst";

import "@/icons"; //引入图标@/icons/index.js
import "@/icons/index.js";

import "ant-design-vue/dist/antd.css";
import "animate.css/animate.css";
import "reset-css/reset.css";
import "viewerjs/dist/viewer.css";
import "nprogress/nprogress.css";
// import 'font-awesome/css/font-awesome.css' // 已通过 cdn 引入
// import 'element-ui/lib/theme-chalk/index.css'; // 已通过 cdn 引入
import "@/assets/icons/icon-base/style.css";
import "@/assets/icons/icon-entity/style.css";
import "@/assets/icons/icon-newsite/style.css";
import "@/assets/_base.scss";
import "@/assets/_skin.scss";
import "@/assets/_common.scss";

import "@/utils/PrototypeExtend.js";
import "@/utils/checkModule";

import { UTableColumn, UTable, UxGrid, UxTableColumn } from "umy-ui";

Vue.use(UTableColumn);
Vue.use(UTable);
Vue.use(UxGrid);
Vue.use(UxTableColumn);
Vue.use(AutoComplete);
Vue.use(window.sgsNav.default);
Vue.use(ELEMENT);
Vue.use(uploader);
Vue.use(Viewer);
Vue.use(Print);
Viewer.setDefaults({
  inline: true,
  button: false, //右上角按钮
  navbar: false, //底部缩略图
  title: false //当前图片标题
  // "url": "data-source"
});
// Vue.prototype.$axios = axios; // 绑定了没有用，注释掉

Vue.prototype.$x2js = new x2js(); //创建x2js对象，挂到vue原型上

Vue.config.productionTip = false;

//全局事件总线
window.EventBus = new Vue();

// 简单配置
NProgress.inc(0.2);
NProgress.configure({ easing: "ease", speed: 500, showSpinner: false });

router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done();
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js